import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './WhyHostNew.css';
import { flowRight as compose } from 'lodash';
import { injectIntl } from 'react-intl';
import Scroll from 'react-scroll'; // Imports all Mixins

import EarnBlock from '../../components/WhyHost/EarnBlock/EarnBlock';
import EasyHost from '../../components/WhyHost/EasyHost/EasyHost';
import Peace from '../../components/WhyHost/Peace/Peace';
import Works from '../../components/WhyHost/Works/Works';
import WhyHostBanner from './WhyHostBanner';
import WhyBlock from '../../components/WhyHost/WhyBlock';
import Loader from '../../components/Loader';
import SharingSection from '../../components/WhyHost/SharingSection/SharingSection';
import { dynamicWhyHostValue } from '../../helpers/GetDynamicItemName/dynamicHomeValue';
import getWhyHostPageSettings from './getWhyHostPageSettings.graphql';
import getWhyHostReview from './getWhyHostReview.graphql';
import { withQuery } from '../../hoc/withGraphql';

let Link = Scroll.Link;
let Element = Scroll.Element;
let Events = Scroll.Events;
let scroll = Scroll.animateScroll;
let scrollSpy = Scroll.scrollSpy;

const WhyHostNew = (props) => {

  const { data: { getWhyHostPage }, title, intl: { locale } } = props
  const { getWhyHostReview: { getHomeWhyHostReview } } = props;

  let settingsCollection = {}

  if (!getWhyHostPage || (getWhyHostPage?.length == 0)) {
    return <Loader type={"text"} />;
  } else {
    getWhyHostPage.map((item, key) => {
      settingsCollection[item.name] = dynamicWhyHostValue(item, locale);
    });

    return (
      <div className="whyhost-content">
        <WhyHostBanner data={settingsCollection} />
        <Element name="scrollSection" className="element">
          <EarnBlock data={settingsCollection} />
          <WhyBlock data={settingsCollection} />
          <EasyHost data={settingsCollection} />
          <Works data={settingsCollection} />
          {getHomeWhyHostReview && getHomeWhyHostReview.results && getHomeWhyHostReview.results.length > 0 && <Peace data={settingsCollection} reviewData={getHomeWhyHostReview.results} />}
          <SharingSection data={settingsCollection} />
        </Element>
      </div>
    );
  }

}

WhyHostNew.propTypes = {
  title: PropTypes.string.isRequired,
};

export default compose(
  injectIntl,
  withStyles(s),
  withQuery(getWhyHostPageSettings, {
    options: {
      fetchPolicy: 'network-only',
      ssr: false
    }
  }),
  withQuery(getWhyHostReview, {
    name: "getWhyHostReview",
    options: {
      fetchPolicy: 'network-only',
      ssr: false
    }
  })
)(WhyHostNew);
